export const dataLibH = [{
  word: 'hach',
  partOfSpeech: 'N',
  definition: ['axe'],
  egSentenceKw: 'I ni on hach nèf.',
  egSentenceEn: 'He has a new axe.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. hache]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'had dòmi',
  partOfSpeech: 'N',
  definition: ['night clothes'],
  egSentenceKw: 'Manman mwen ka lavé sé had dòmi-an.',
  egSentenceEn: 'My mother is washing the night clothes.',
  synonym: ['abiman', 'lenj'],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'had ben',
  partOfSpeech: 'N',
  definition: ['bathing suit'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'hèlsenta',
  partOfSpeech: 'N',
  definition: ['health center'],
  egSentenceKw: 'Dòktè-a ka vini an hèlsenta-a jòdi-a.',
  egSentenceEn: 'The doctor is coming to the health center today.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. health center]',
  dialect: '🇱🇨',
  variant: ['gwòg'],
}, {
  word: 'hòd',
  partOfSpeech: 'PREP',
  definition: ['from', 'away from'],
  egSentenceKw: 'Mwen ka twavay senk lyé hòd kay mwen.',
  egSentenceEn: 'I work five miles from my home.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. hors de]',
  dialect: '🇱🇨',
  variant: [null],
},
];
